import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ds-page-header',
  standalone: false,
  template: `
    <header class="ds-page-header">
      <h2 class="ds-title">{{ title }}</h2>
      @if (subtitle) {
        <p class="ds-page-subtitle">{{ subtitle }}</p>
      }
      <ng-content></ng-content>
    </header>
  `,
})
export class DsPageHeader {
  @Input() title = '';
  @Input() subtitle = '';
}
